/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import cx from 'classnames';
import * as React from 'react';
import { useTheme } from '../utils/index.js';
import '@itwin/itwinui-css/css/information-panel.css';
/**
 * InformationPanelWrapper should contain the `InformationPanel`
 * and the component over which the panel will overlay.
 * @example
 * <InformationPanelWrapper>
 *   <Table ... />
 *   <InformationPanel ... />
 * </InformationPanelWrapper>
 */
export const InformationPanelWrapper = (props) => {
    const { className, children, ...rest } = props;
    useTheme();
    return (React.createElement("div", { className: cx('iui-information-panel-wrapper', className), ...rest }, children));
};
export default InformationPanelWrapper;
